import type { GuideSlice } from '../bs/guide'

/**
 * English for the chrome around the guide.
 *
 * The guide itself is not here and is not translated here either: it arrives
 * from `/api/guide`, already in the reader's language, because the same text is
 * printed in the PDF. `lang/en/guide.php` is where the English of the document
 * lives.
 *
 * Complete rather than partial — see en/index.ts.
 */
export const guide: GuideSlice = {
  'guide.contents': 'Contents',

  'guide.download': 'Download the guide (PDF)',

  'guide.empty': 'No steps have been written for your role yet. Tell your administrator.',

  'guide.figure.enlarge': 'Enlarge the picture: {alt}',

  'guide.preview.label': 'Show the guide for',
  'guide.preview.note':
    'This is the guide a colleague with the role {role} sees. Your own role is unchanged — this is a preview.',
}
